import script from "./BulkAssignAssignedVouchersDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkAssignAssignedVouchersDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__